<section class="section-tournois">

  <div class="header-section">
    <h2 class="titre-section">Nos tournois JCC</h2>
  </div>

  <div class="frise-tournois">

    <a class="tournoi-item" target="_blank" *ngFor="let jeu of jeux" [href]="jeu.lien">
      
      <div class="bg-image" [style.background-image]="'url(' + jeu.img + ')'"></div>
      
      <div class="bulle-info">
        <div class="contenu-bulle">
          <p class="intro">Participez à un tournois</p>
          <img [src]="jeu.logo" [alt]="jeu.nom" class="logo-jeu">
        </div>
      </div>
      
    </a>

  </div>

</section>